import { useState } from 'react'

import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

import { Button } from '@material-ui/core'

import constants from 'constants/index'

import {
  ConfirmationDialog,
  ExportQuestionnairePdf,
  Permitted,
} from 'components'
import {
  ExportDataProcessesDialog,
  ExportRipdDialog,
  FormDecreaseQuestionnaireLevelDialog,
  FormDeleteDialog,
  ImportDataProcessesDialog,
} from '../'

import * as service from 'service'

import useSnackbar from 'hooks/useSnackbar'
import helpers from 'helpers'

import { routes } from 'Routes'
import { isNil } from 'lodash'

const ActionButtons = ({
  company,
  refresh = () => {},
  setIsloading = () => {},
}) => {
  const match = useLocation()
  const isEasy = match?.pathname === routes.companies.easy

  const [openActivateDialog, setOpenActivateDialog] = useState(false)
  const [openInactivateDialog, setOpenInactivateDialog] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [openExportModal, setOpenExportModal] = useState(false)
  const [openImportDataProcesses, setOpenImportDataProcesses] = useState(false)
  const [openExportRipd, setOpenExportRipd] = useState(false)
  const [isGenerate, setIsGenerate] = useState(false)
  const [openDecreaseLevelDialog, setOpenDecreaseLevelDialog] = useState(false)

  const snackbar = useSnackbar()

  const companyIsInactive =
    company?.statusId === constants.companies.STATUSES.INACTIVE
  const isKindSupplier = company?.kind === constants.companies.KINDS.SUPPLIER

  const handleActiveOrInactive = async () => {
    try {
      await service.dponet.companies.changeStatus({ companyId: company?.id })

      snackbar.open({
        message: `Empresa ${
          companyIsInactive ? 'ativada' : 'inativada'
        } com sucesso!`,
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: `Falha ao ${
          companyIsInactive ? 'ativar' : 'inativar'
        } empresa.`,
        variant: 'error',
      })
    }
    setOpenActivateDialog(false)
    setOpenInactivateDialog(false)
    refresh()
  }

  const generateClient = async () => {
    setIsloading(true)
    try {
      await service.dponet.companies.generateClient(company?.id)

      snackbar.open({
        message: 'Sucesso! Cliente gerado com sucesso',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Erro ao gerar o cliente a partir da empresa',
        ),
        variant: 'error',
      })
    } finally {
      setIsloading(false)
      setIsGenerate(false)
    }
  }

  const handleUpgradeSupplier = async () => {
    setIsloading(true)
    try {
      await service.dponet.companies.upgradeSupplierToClient(company?.id)

      snackbar.open({
        message: 'Empresa convertida em empresa real com sucesso',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Erro ao converter empresa em em real',
        ),
        variant: 'error',
      })
    } finally {
      setIsloading(false)
    }
  }

  const handleInactivateOrAcivate = () =>
    companyIsInactive
      ? setOpenActivateDialog(true)
      : setOpenInactivateDialog(true)

  return (
    <>
      <Permitted tag={constants.permissions.COMPANIES.INACTIVE_AND_ACTIVE}>
        {!isKindSupplier && (
          <Button fullWidth size="small" onClick={handleInactivateOrAcivate}>
            {companyIsInactive ? 'Ativar' : 'Inativar'}
          </Button>
        )}
      </Permitted>
      <Permitted tag={constants.permissions.COMPANIES.DELETE}>
        <Button
          fullWidth
          size="small"
          onClick={() => {
            setOpenDeleteDialog(true)
          }}
        >
          Excluir
        </Button>
      </Permitted>
      <Permitted
        tag={constants.permissions.COMPANIES.UPDATE_QUESTIONNAIRE_LEVEL}
      >
        <Button
          fullWidth
          size="small"
          onClick={() => setOpenDecreaseLevelDialog(true)}
        >
          Diminuir nível dos Questionários
        </Button>
      </Permitted>
      {!isEasy && (
        <>
          <Permitted
            tag={constants.permissions.COMPANIES.EXPORT_DATA_PROCESSES}
          >
            <Button
              fullWidth
              size="small"
              onClick={() => {
                setOpenExportModal(true)
              }}
            >
              Exportar processos
            </Button>
          </Permitted>
          {/* {!helpers.companies.isTemplate(company) && (
            <Permitted tag={constants.permissions.RIPD.EXPORT_ADMIN}>
              <Button
                fullWidth
                size="small"
                onClick={() => {
                  setOpenExportRipd(true)
                }}
              >
                Exportar RIPD
              </Button>
            </Permitted>
          )} */}
          <Permitted tag={constants.permissions.COMPANIES.CREATE}>
            <Button
              fullWidth
              size="small"
              onClick={() => {
                setOpenImportDataProcesses(true)
              }}
            >
              Importar processos
            </Button>
          </Permitted>

          {isNil(company?.preRegistration) && (
            <Button onClick={() => setIsGenerate(true)} size="small">
              Gerar cliente (vendas)
            </Button>
          )}
          {isKindSupplier && (
            <Button onClick={handleUpgradeSupplier} size="small">
              Converter em real
            </Button>
          )}
          {!!company?.name && (
            <ExportQuestionnairePdf company={company} fullWidth />
          )}
        </>
      )}

      <ConfirmationDialog
        open={openActivateDialog}
        setOpen={setOpenActivateDialog}
        message="Tem certeza que deseja ativar esta empresa?"
        cancelButtonText="Cancelar"
        buttonText="Ativar"
        actionAcceptButton={handleActiveOrInactive}
      />
      <ConfirmationDialog
        open={openInactivateDialog}
        setOpen={setOpenInactivateDialog}
        message="Tem certeza que deseja inativar esta empresa?"
        cancelButtonText="Cancelar"
        buttonText="Inativar"
        actionAcceptButton={handleActiveOrInactive}
      />
      <FormDeleteDialog
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog}
        companyId={company?.id}
        refresh={refresh}
      />
      <FormDecreaseQuestionnaireLevelDialog
        open={openDecreaseLevelDialog}
        setOpen={setOpenDecreaseLevelDialog}
        companyId={company?.id}
        refresh={refresh}
      />
      <ExportDataProcessesDialog
        open={openExportModal}
        setOpen={setOpenExportModal}
        companyId={company?.id}
      />
      <ImportDataProcessesDialog
        open={openImportDataProcesses}
        setOpen={setOpenImportDataProcesses}
        companyId={company?.id}
      />
      <ExportRipdDialog
        open={openExportRipd}
        setOpen={setOpenExportRipd}
        companyId={company?.id}
      />
      {isGenerate && (
        <ConfirmationDialog
          setOpen={setIsGenerate}
          open={isGenerate}
          message="Deseja gerar o cliente a partir da empresa?"
          subMessage="O cliente será gerado e após isso você poderá acessa-lo 
                            na lista de clientes, lembre-se de ir para o cliente e 
                            conferir se os dados estão corretos."
          actionAcceptButton={generateClient}
        />
      )}
    </>
  )
}

ActionButtons.propTypes = {
  company: PropTypes.object,
  refresh: PropTypes.func,
  setIsloading: PropTypes.func,
}

export default ActionButtons
